import IUserGet from 'api/interfaces/users/IUserGet';
import api from './api';

export default {
  getCurrentUser: async (withoutTokenRefresh?: boolean): Promise<IUserGet[]> =>
    api.get('/api/v1/user', undefined, withoutTokenRefresh),
  getAll: async (): Promise<IUserGet[]> => api.get('/api/v1/users'),
};
